export default "__VITE_ASSET__0eb6674e__"